import { api } from "../lib/api";
import { toast } from "sonner";

export async function downloadDocument(id, title, ext = "pdf") {
  const res = await api.get(`/documents/${id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${title || "document"}.${ext}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function handlePdfError(e) {
  if (e?.response?.status === 402) {
    toast.error("You're out of credits", { description: "Top up to keep creating PDFs." });
    return "no-credits";
  }
  toast.error("Could not generate PDF", { description: e?.response?.data?.detail || "Please try again." });
  return "error";
}
